import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Inset, Pane, Text, TextLink } from '@criteria-labs/react'
import React from 'react'

export class ErrorBoundary extends React.Component<React.PropsWithChildren<{}>, { error?: Error }> {
  constructor(props: React.PropsWithChildren<{}>) {
    super(props)
    this.state = {}
  }

  static getDerivedStateFromError(error: Error) {
    return {
      error
    }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error(`${error.message}\n\n${errorInfo.componentStack}`)
  }

  render() {
    if (this.state.error) {
      return (
        <Pane background="secondary">
          <Inset className="flex h-full flex-col items-center justify-center gap-3 sm:gap-4">
            <ExclamationTriangleIcon className="h-6 w-6 text-zinc-500 dark:text-zinc-400" />
            <Text>Sorry, we can&apos;t display this API. Check the document is valid.</Text>
            <Text>
              <TextLink href="mailto:support@criteria.sh">Report this error.</TextLink>
            </Text>
          </Inset>
        </Pane>
      )
    }
    return this.props.children
  }
}
